import React from 'react';
import { useCharitableGivingContext } from '../../context/useCharitableGivingContext';
import { ReviewItem } from '../Review/components/ReviewItem';

export const KindOfPropertyReview = () => {
  const {
    workflow: {
      data: { kindOfProperty },
      options: { kindOfPropertyOptions },
    },
  } = useCharitableGivingContext();

  const getKindOfProperty = () => {
    if (kindOfProperty !== null) {
      const foundKindOfProperty = kindOfPropertyOptions.find(
        ({ value }) => value === kindOfProperty,
      );

      if (foundKindOfProperty) {
        return foundKindOfProperty.label;
      }
    }

    return '—';
  };

  return <ReviewItem label="Property Type" value={getKindOfProperty()} />;
};
